module.exports = __webpack_public_path__ + "static/media/bespoke-tree-sphere.c487b6d4.svg";